export enum Orientation {
  Unknown = 0,
  Landscape = 1,
  LeftPortrait = 2,
  RightPortrait = 3
}
